<template>
  <page
    :title="device ? 'Device - #' + device.id : ''"
    :backTo="getPreviousUrl"
    :loading="device === null"
    size="is-desktop"
  >
    <div class="box" v-if="device">
      <div class="level">
        <div class="level-left">
          <div class="media" style="align-items: center;">
            <figure class="media-left">
              <p class="image is-64x64">
                <device-image
                  v-if="device.model"
                  :model="device.model"
                  style="height: 64px; width: 64px;"
                ></device-image>
              </p>
            </figure>
            <div>
              <div class="title is-5">{{ device.code }}</div>

              <div class="subtitle">{{ device.manufacturer + " : " + device.model }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="device">
      <div class="tabs is-marginless">
        <ul>
          <router-link tag="li" :to="`/devices/${device.id}`">
            <a>General Info</a>
          </router-link>

          <router-link tag="li" :to="`/devices/${device.id}/users`">
            <a>User</a>
          </router-link>
        </ul>
      </div>

      <div class="card-content is-paddingless">
        <router-view :device="device"></router-view>
      </div>
    </div>
  </page>
</template>

<script>
import DeviceImage from "../../../../components/DeviceImage";

export default {
  components: {
    DeviceImage
  },

  data() {
    return {
      device: null
    };
  },
  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    }
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/devices/" + this.$route.params.id)
        .then(response => {
          this.device = response.data.data;
        })
        .catch(() => {
          alert("Couldn't fetch data from the server.");
        });
    }
  }
};
</script>
